import axios from 'axios';
import { Loading, Message, MessageBox } from 'element-ui';
import router from '../router';
import { refreshToken } from './request';

const instance = axios.create({
    // baseURL: 'http://yike.e-class.me/',
    // timeout: 3000
});

let loadingInstance = null;
let isRefreshing = false;
let requests = [];

/* 请求拦截器 */
instance.interceptors.request.use(
    config => {
        const isLoading = config.loading !== undefined ? config.loading : true;
        if (isLoading) {
            loadingInstance = Loading.service({
                lock: true,
                text: '加载中...',
                spinner: 'el-icon-loading',
            });
        }

        if (localStorage.getItem('token')) {
            config.headers.Authorization = localStorage.getItem('token');
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

/* 响应拦截器 */

instance.interceptors.response.use(
    async response => {
        loadingInstance && loadingInstance.close();
        if (response.data.status === 204) {
            Message({
                type: 'warning',
                message: '登录失效，请重新登录',
                onClose: () => {
                    // localStorage.clear();
                    // window.location.href = '/#/';
                },
            });
        }
        if (response.data.code === 4000) {
            MessageBox('比赛结束啦', '提示消息', {
                confirmButtonText: '确定',
            }).then(() => {
                localStorage.clear();
                router.push({
                    path: '/',
                });
            });
        }
        const { config } = response;

        if (response.data.status === 401) {
            if (isRefreshing) {
                return new Promise(resolve => {
                    requests.push(() => resolve(instance(config)));
                });
            }
            isRefreshing = true;
            try {
                const token = await refreshToken();
                console.log('token', token);
                config.headers.Authorization = token;
                requests.forEach(cb => cb());
                requests = [];
                return instance(config);
            } catch (err) {
                console.log('refreshError', err);
                // setTimeout(() => {
                //     localStorage.clear();
                //     router.push({
                //         path: '/',
                //     });
                // }, 2000);
                return Promise.reject(err);
            } finally {
                isRefreshing = false;
            }
        }
        return response.data;
    },
    error => {
        loadingInstance && loadingInstance.close();
        return Promise.reject(error);
    }
);

const Http = {};

Http.axiosGetByOption = (url, params, options, callback, reject) => {
    instance
        .get(url, { params: params, ...options })
        .then(callback)
        .catch(reject);
};

/* get方法参数以param对象传参 */
Http.axiosGetBy = (url, params, callback, reject) => {
    instance.get(url, { params: params }).then(callback).catch(reject);
};

/* get方法参数跟在url中 */
Http.axiosGet = (url, callback, reject) => {
    instance.get(url).then(callback).catch(reject);
};

Http.asyncGet = (url, params) => {
    return instance.get(url, { params: params });
};

Http.asyncPost = (url, params) => {
    return instance.post(url, params);
};

/* post方法 */
Http.axiosPost = (url, params, callback, reject) => {
    instance.post(url, params).then(callback).catch(reject);
};

/* 上传文件 */
Http.axiosFile = (url, formData, callback, reject) => {
    let config = {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    };
    instance.post(url, formData, config).then(callback).catch(reject);
};
/*-无加载状态的请求-*/
// const requestInstance = axios.create({});

// requestInstance.interceptors.request.use(
//     config => {
//         if (localStorage.getItem('token')) {
//             config.headers.Authorization = localStorage.getItem('token');
//         }
//         return config;
//     },
//     error => {
//         return Promise.reject(error);
//     }
// );

// requestInstance.interceptors.response.use(
//     response => {
//         return response.data;
//     },
//     error => {
//         return Promise.reject(error);
//     }
// );

Http.onlyPost = (url, params, callback, reject) => {
    instance.post(url, params, { loading: false }).then(callback).catch(reject);
};
Http.onlyGet = (url, callback, reject) => {
    instance.get(url, { params: {}, loading: false }).then(callback).catch(reject);
};

Http.onlyGetBy = (url, params, callback, reject) => {
    instance.get(url, { params: params, loading: false }).then(callback).catch(reject);
};

export default Http;
export { instance };
